import { Button } from "@light-technology/components";
import type { Control, UseFormHandleSubmit } from "react-hook-form";
import type { AppResponse, PlanDetailResponse } from "../../state/api.types";
import type { FormValues } from "./common";
import { PublishButton } from "./PublishButton";
import type { RenewalPlanOption } from "./renewalPlan";

type FooterProps = {
  app: AppResponse;
  plan: PlanDetailResponse;
  handleSubmit: UseFormHandleSubmit<FormValues>;
  control: Control<FormValues>;
  renewalPlanOptions: RenewalPlanOption[];
};

export const Footer = ({
  app,
  plan,
  handleSubmit,
  control,
  renewalPlanOptions,
}: FooterProps) => {
  return (
    <div className="sticky bottom-0 border-t border-t-secondary bg-primary pt-xl pb-2xl">
      <div className="flex flex-row justify-between gap-xl px-4xl">
        <div />
        <div className="flex flex-row gap-xl">
          <Button size="md" color="tertiary" href={`/apps/${app.slug}/plans/`}>
            Cancel changes
          </Button>
          <PublishButton
            app={app}
            plan={plan}
            handleSubmit={handleSubmit}
            control={control}
            renewalPlanOptions={renewalPlanOptions}
          />
        </div>
      </div>
    </div>
  );
};
